import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "react-apollo";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { ShowNotice } from "Store";
import { mutationAddNoteToCaseInfo } from "Apollo";
import TextArea from "./TextArea";

export default graphql(mutationAddNoteToCaseInfo)(
  observer(
    class CaseNote extends Component {
      static propTypes = { note: PropTypes.string };
      states = observable({
        text: "",
        isLoading: false,
        isMutationDone: false,
        initialValue: ""
      });

      componentWillMount() {
        const note = this.props.note;
        this.states.text = note;
        this.states.initialValue = note;
      }

      componentWillReceiveProps(nextProps) {
        const note = nextProps.note;
        this.states.text = note;
        this.states.initialValue = note;
      }

      render() {
        return (
          <TextArea
            {...this.props}
            value={this.states.text}
            onChange={this.onChange}
            onSave={this.onSaveNote}
            isLoading={this.states.isLoading}
            isMutationDone={this.states.isMutationDone}
            initialValue={this.states.initialValue}
          />
        );
      }

      onChange = text => {
        this.states.text = text;
      };

      onSaveNote = async () => {
        this.states.isLoading = true;
        try {
          await this.props.mutate({
            variables: {
              case: {
                id: this.props.case.id
              },
              content: this.states.text
            }
          });
          ShowNotice("note-save-success");
        } catch (error) {
          ShowNotice("note-save-error");
        }
        this.states.isLoading = false;
        this.states.isMutationDone = true;
        setTimeout(() => {
          this.states.isMutationDone = false;
        }, 1500);
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/module-case-management/info-panel/CaseNoteWithMutation.js